module.exports = __webpack_public_path__ + "static/media/porte.b2dffc0e.mp4";